// extracted by mini-css-extract-plugin
module.exports = {"marginbottomlistmobile":"styles_marginbottomlistmobile__4QHZo"};